module.exports = __webpack_public_path__ + "img/egg_fish_sad.a1c71796.svg";